<template>
  <div class="row" id="mainBody">
    <div class="col-lg-10 col-md-9 mainPanel">
      <form @submit.prevent="submit()">
        <div class="textEditor form-group">
          <label for="">Naam</label>
          <input
            autocomplete="false"
            v-model="help.name"
            type="text"
            class="form-control"
          />
        </div>
        <div class="textEditor form-group">
          <label for="">Auteur</label>
          <select2 class="" :options="users" v-model="help.user_id" />
        </div>
        <div class="textEditor form-group">
          <label for="">Versie</label>
          <input type="number" class="form-control" v-model="help.version" />
        </div>
        <div class="textEditor form-group">
          <label for="">Permissie</label>
          <select2-multiple-control
            :options="permissions"
            v-model="help.permission"
            placeholder="Choose users or enter a valid emailaddresses"
          />
        </div>
        <div class="textEditor form-group">
          <label for="">Routenaam </label>
          <input
            autocomplete="false"
            v-model="help.path"
            type="text"
            class="form-control"
          />
        </div>
        <div class="textEditor mb-3">
          <div class="content-title-wrap">
            <label for="">Content</label>
            <button type="button" @click="addContent" class="content-btn-wrap">
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <!-- <form> -->
          <div
            class="help-cont-wrap"
            :class="{ 'help-inner-wrap': this.content.length > 0 }"
            id="multiCollapseExample2"
            ref="helpCollapse"
          >
            <div
              class="help-inner-wrap mb-16"
              v-for="(input, index) in content"
              :key="'content-value' + index"
            >
              <div class="content-title-wrap">
                <label for="">Helpsectie</label>
                <div
                  class="mt-3 d-flex justif-content-start align-items-center"
                >
                  <span
                    v-if="index !== 0"
                    @click="reOrder(content, index, index - 1)"
                    type="button"
                    class="btn btn-outline-success btn-sm rounded-btn mr-1"
                  >
                    <i class="fas fa-arrow-up"></i>
                  </span>
                  <span
                    @click="reOrder(content, index, index + 1)"
                    v-if="index + 1 !== content.length"
                    type="button"
                    class="btn btn-outline-danger btn-sm rounded-btn"
                  >
                    <i class="fas fa-arrow-down"></i>
                  </span>
                  <button
                    class="content-btn-wrap no-border ml-1"
                    type="button"
                    data-toggle="collapse"
                    data-target="#multiCollapseExample2"
                    @click="hideContent(index)"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="help-inp-wrap">
                <label for="">Titel</label>
                <input type="text" class="form-control" v-model="input.title" />
              </div>
              <div class="help-inp-wrap">
                <label for="">Afbeelding</label>
                <input
                  type="file"
                  multiple
                  class="form-control"
                  accept="image/png, image/gif, image/jpeg"
                  @change="images($event, index)"
                />
                <div class="content-image-wrap">
                  <ul class="content-image-ul">
                    <li
                      class="content-image-li py-2"
                      v-for="(img, imageIndex) in input.images"
                      :key="imageIndex"
                    >
                      <div class="d-flex flex-column">
                        <small class="mb-1 img-name">{{ img.name }}</small>
                        <img
                          :src="imgObject(img)"
                          width="100"
                          height="100"
                          alt=""
                          class="border-radius--img"
                        />
                      </div>
                      <a
                        @click="removeImg(imageIndex, index)"
                        href="javascript:void(0)"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-inp-wrap">
                <label for="">Bestand</label>
                <input
                  type="file"
                  multiple
                  class="form-control"
                  @change="files($event, index)"
                />
                <div class="content-image-wrap">
                  <ul class="content-image-ul">
                    <li
                      class="content-image-li"
                      v-for="(file, fileIndex) in input.files"
                      :key="fileIndex"
                    >
                      <small>{{ file.name }}</small>
                      <a
                        @click="removeFile(fileIndex, index)"
                        href="javascript:void(0)"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-inp-wrap">
                <label for="">Content</label>
                <editor
                  :init="{
                    height: 300,
                    menubar: false,
                    language: 'nl',
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor | \
                                            alignleft aligncenter alignright alignjustify | \
                                            bullist numlist outdent indent | link code | paste | fullscreen | removeformat | help',
                  }"
                  v-model="input.content"
                />
              </div>
            </div>
          </div>
          <!-- </form> -->
          <div class="help-content-container">
            <div
              class="help-content-cont2 d-none"
              v-for="(content, index) in help.content"
              :key="index"
            >
              <div class="d-flex content-arr-cont">
                <h6 class="cont-h6">{{ content.title }}</h6>
                <div class="content-arr-wrap">
                  <button
                    v-if="index != 0"
                    class="content-btn-wrap no-border"
                    type="button"
                    data-toggle="collapse"
                    data-target="#multiCollapseExample2"
                    @click="swap(index, 'up')"
                  >
                    <i class="fa fa-chevron-up"></i>
                  </button>
                  <button
                    v-if="index != help.content.length - 1"
                    class="content-btn-wrap no-border"
                    type="button"
                    data-toggle="collapse"
                    data-target="#multiCollapseExample2"
                    @click="swap(index, 'down')"
                  >
                    <i class="fa fa-chevron-down"></i>
                  </button>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">Afbeelding</p>
                <div class="content-image-wrap">
                  <ul class="content-image-ul">
                    <li
                      class="content-image-li"
                      v-for="(img, index) in content.images"
                      :key="index"
                    >
                      <small>{{ img.name }}</small>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">Bestand</p>
                <div class="content-image-wrap">
                  <ul class="content-image-ul mt-0 content-img-ul2">
                    <li
                      class="content-image-li"
                      v-for="(file, index) in content.files"
                      :key="index"
                    >
                      <small>{{ file.name }}</small>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="help-img2-cont">
                <p class="cont2-p">Content</p>
                <p class="cont-txt-p" v-html="content.content"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="textEditor form-group" v-if="user.id == 1">
          <label for="core">Core</label>
          <input
            type="checkbox"
            v-model="help.core"
            id="core"
            class="help-core"
          />
        </div>
        <!-- <div v-if="message.length > 0" class="alert alert-success">
                    <p>
                    {{ message }}
                    </p>
                </div> -->
        <button class="btn btn-success">
          <i class="fa fa-save"></i> Opslaan
        </button>
      </form>
    </div>
    <div class="col-lg-2 col-md-3">
      <button
        data-toggle="modal"
        data-target="#emailPreview"
        class="btn btn-dark text-white"
      >
        <i class="fa fa-eye"></i> Voorbeeld
      </button>
      <div
        class="modal fade"
        id="emailPreview"
        tabindex="-1"
        role="dialog"
        aria-labelledby="emailPreview"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header" style="border-bottom: unset">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <!-- <div class="modal-body" v-if="preview_loading">
                Aan het laden...
                </div>
                <div class="modal-body" v-else v-html="preview_content"></div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Select2MultipleControl from "v-select2-multiple-component";

export default {
  components: {
    Select2MultipleControl,
  },
  data() {
    return {
      message: "",
      contentShow: false,
      help: {
        name: "",
        version: "",
        core: "",
        user_id: "",
        permission: "",
        path: "",
        content: [],
      },
      content: [],
      permissions: [],
      users: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    imgObject(image) {
      return URL.createObjectURL(image);
    },
    addContent() {
      this.content = [
        ...this.content,
        {
          images: [],
          files: [],
          title: "",
          content: "",
        },
      ];
    },
    reOrder(arr, from, to, on = 1) {
      if (Array.isArray(arr)) {
        arr.splice(to, 0, ...arr.splice(from, on));
      }
    },
    hideContent(index) {
      if (index === 0) {
        this.content.shift();
        return;
      }
      this.content.splice(index, 1);
    },
    images(event, index) {
      var images = event.target.files;
      for (const i of Object.keys(images)) {
        this.content[index].images.push(images[i]);
      }
    },
    files(event, index) {
      var files = event.target.files;
      for (const i of Object.keys(files)) {
        this.content[index].files.push(files[i]);
      }
    },
    removeImg(id, index) {
      this.content[index]["images"] = this.content[index]["images"].filter(
        (img, index2) => index2 != id
      );
    },
    removeFile(id, index) {
      this.content[index]["files"] = this.content[index]["files"].filter(
        (file, index2) => index2 != id
      );
    },
    swap(index, position) {
      var contents = [...this.help.contents];
      var index2 = index;
      if (position == "up") {
        index2 -= 1;
      } else {
        index2 += 1;
      }
      var temp = contents[index];
      contents[index] = contents[index2];
      contents[index2] = temp;

      this.help.contents = contents;
    },
    submit() {
      var form = new FormData();
      for (const key in this.help) {
        form.append(key, this.help[key]);
      }
      form.append("content", JSON.stringify(this.content));
      this.content.forEach((item, key) => {
        item.images.forEach((image, key2) => {
          form.append("image" + "_" + key + "_" + key2, image);
        });
        item.files.forEach((file, key2) => {
          form.append("file" + "_" + key + "_" + key2, file);
        });
      });
      this.$store
        .dispatch("post", {
          endpoint: "/api/v1/store-help",
          details: form,
        })
        .then(() => {
          this.$store.dispatch("auth/makeNotification", {
            status: "",
            statusText: "help-page was created successfully",
          });
          window.location.href = "/settings/help";
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    getUsers() {
      this.$store
        .dispatch("get", "/api/v1/users/all")
        .then((data) => {
          var temp = data.data.data;
          var users = temp.map((user) => {
            return {
              id: user.id,
              text: user.display_name,
            };
          });

          this.users = [...users];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPermissions() {
      this.$store
        .dispatch("get", "/api/v1/permissions")
        .then((data) => {
          var temp = data.data;
          var permissions = temp.map((permission) => {
            return {
              id: permission.id,
              text: permission.name,
            };
          });
          this.permissions = [...permissions];
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getUsers();
    this.getPermissions();
  },
};
</script>

<style lang="css" scoped>
.modal-body table {
  width: 100% !important;
}
.mb-16 {
  margin-bottom: 16px;
}
.border-radius--img {
  border-radius: 10px;
}
</style>
